import axiosInstance from './axiosInstance';

const AbsenceService = {
    getByEmployee: (employeeId) =>
        axiosInstance.get(`/api/employees/${employeeId}/absences`).then(r => r.data),

    getSummary: (employeeId, year) =>
        axiosInstance.get(`/api/employees/${employeeId}/absences/summary?year=${year}`).then(r => r.data),

    create: (employeeId, dto) =>
        axiosInstance.post(`/api/employees/${employeeId}/absences`, dto).then(r => r.data),

    approve: (absenceId) =>
        axiosInstance.post(`/api/absences/${absenceId}/approve`).then(r => r.data),

    reject: (absenceId, reviewNote) =>
        axiosInstance.post(`/api/absences/${absenceId}/reject`, { reviewNote }).then(r => r.data),

    convertToSick: (absenceId, splitStart, splitEnd, reason) =>
        axiosInstance.post(`/api/absences/${absenceId}/convert-to-sick`, { reason }, {
            params: { splitStart, splitEnd },
        }).then(r => r.data),

    delete: (absenceId) =>
        axiosInstance.delete(`/api/absences/${absenceId}`).then(r => r.data),

    getPending: () =>
        axiosInstance.get('/api/absences/pending').then(r => r.data),

    getInRange: (start, end) =>
        axiosInstance.get('/api/absences/range', { params: { start, end } }).then(r => r.data),

    overlapCheck: (employeeId, start, end) =>
        axiosInstance.get('/api/absences/overlap-check', { params: { employeeId, start, end } }).then(r => r.data),

    setCarryOver: (employeeId, year, days) =>
        axiosInstance.put(`/api/employees/${employeeId}/absences/carry-over`, null, {
            params: { year, days },
        }).then(r => r.data),

    // "My" endpoints — no employee ID needed, resolved server-side
    getMy: () =>
        axiosInstance.get('/api/absences/my').then(r => r.data),

    getMySummary: (year) =>
        axiosInstance.get('/api/absences/my/summary', { params: year ? { year } : {} }).then(r => r.data),

    createMy: (dto) =>
        axiosInstance.post('/api/absences/my', dto).then(r => r.data),

    // Public holidays
    getHolidays: (year) =>
        axiosInstance.get('/api/public-holidays', { params: { year } }).then(r => r.data),

    createHoliday: (dto) =>
        axiosInstance.post('/api/public-holidays', dto).then(r => r.data),

    deleteHoliday: (id) =>
        axiosInstance.delete(`/api/public-holidays/${id}`).then(r => r.data),
};

export default AbsenceService;
